import { Icon } from '@iwoca/orion';
import styles from '../ProductOffers.module.css';

type TIconType =
  | 'calendarOutline'
  | 'timerOutline'
  | 'presentationOutline'
  | 'pound'
  | 'filePlusInside'
  | 'lightningBolt'
  | 'checkSquare';

export const IconWithText = ({
  icon,
  text,
}: {
  icon: TIconType;
  text: string;
}) => {
  return (
    <>
      <Icon
        icon={icon}
        height={24}
        width={24}
        className={styles.icon}
        data-testid={`${icon}-icon`}
      />
      {text}
    </>
  );
};
